import Storage from 'storage';

export const isLocal = () => {
  return window.location.hostname === 'localhost';
};

export const isDevAccount = () => {
  if (isLocal()) return true;

  const organization = Storage.get('organization');
  const user = Storage.get('user');

  if (!user || !organization) return false;

  if (organization.name !== 'MyChoice') return false;

  return user.username === 'admin';
};

export const parseDateString = (
  dateStr: string | null | undefined,
): Date | null => {
  if (!dateStr) return null;
  const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;

  const year = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);

  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

export const formatDateInput = (value: string): string => {
  const numbers = value.replace(/[^0-9]/g, '');

  if (numbers.length <= 4) {
    return numbers;
  } else if (numbers.length <= 6) {
    return `${numbers.slice(0, 4)}-${numbers.slice(4)}`;
  } else {
    return `${numbers.slice(0, 4)}-${numbers.slice(4, 6)}-${numbers.slice(6, 8)}`;
  }
};

export const formatDateToString = (date: Date | null): string | null => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
